<template>
    <div :class="'sticky-banner ' + (loading ? 'loading' : '')" v-if="showBanner">
        <div class="sticky-banner--wrap" @click="clickedBanner()">
            <div class="sticky-banner--text">
                <div class="sticky-banner--text--left">
                    <span v-html="sticky.textLeft"></span>
                    <div class="sticky-banner--icon">
                        <svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.40772 123.807C1.92834 123.807 0 121.74 0 119.399C0 118.159 0.41323 117.057 1.37743 116.231L15.1518 102.594C-7.30039 76.6988 -4.40782 37.5797 21.4879 15.1275C47.3837 -7.32466 86.5028 -4.43259 108.955 21.4631C131.407 47.3589 128.515 86.478 102.619 108.93C91.3238 118.71 76.9985 124.082 62.1222 124.082L4.40772 123.807Z" fill="#39414E"/>
                            <path d="M52.4367 48.9328C52.6611 49.7742 52.9976 50.6156 53.4463 51.3447C53.8951 52.0738 54.3999 52.803 55.0169 53.4201C55.6339 54.0372 56.3069 54.5419 57.0923 54.9906C57.8215 55.4394 58.6628 55.7759 59.5041 56.0003C60.3454 56.2246 61.2429 56.3929 62.1965 56.3929C63.1501 56.3929 64.1036 56.2807 64.945 56.0003C65.8424 55.7198 66.6837 55.3833 67.413 54.9346L67.6934 54.7663L66.4594 52.6909L66.179 52.8591C65.562 53.1957 64.945 53.4761 64.2719 53.7005C62.9257 54.0931 61.4674 54.0931 60.1212 53.7005C59.4481 53.5322 58.8312 53.2518 58.2701 52.9152C57.7091 52.5787 57.1483 52.186 56.6996 51.6812C56.2509 51.2325 55.8021 50.6716 55.4656 50.1107C55.2412 49.662 55.0169 49.2132 54.8486 48.6523C54.7925 48.5402 54.7364 48.3719 54.7364 48.2597C54.5681 47.5866 54.456 46.9135 54.456 46.1843C54.456 45.455 54.5681 44.7819 54.7364 44.165C54.9047 43.4919 55.1851 42.875 55.5217 42.314C55.7461 41.9213 56.0265 41.5848 56.307 41.2482C56.4191 41.08 56.5874 40.9117 56.7557 40.7434C57.2044 40.2947 57.6531 39.9021 58.214 39.6216C58.2701 39.6216 58.2701 39.5655 58.3262 39.5655C58.8871 39.229 59.5041 38.9485 60.1773 38.7802C61.3552 38.4437 62.7014 38.4437 63.9353 38.6681C64.0475 38.6681 64.2157 38.7242 64.3279 38.7802C65.001 38.9485 65.6179 39.1729 66.179 39.5094C66.74 39.846 67.3008 40.2386 67.7495 40.6312C68.1982 41.08 68.647 41.5287 68.9274 42.0896C69.264 42.5944 69.5444 43.2114 69.7127 43.7723C69.881 44.3893 69.9931 45.0063 69.9931 45.6234C69.9931 46.1843 69.9371 46.6891 69.881 47.0257C69.8249 47.4183 69.6566 47.7549 69.4883 48.0914C69.3201 48.428 69.0957 48.7084 68.8152 48.9328C68.5348 49.1571 68.1982 49.2693 67.8056 49.2693C67.6373 49.2693 67.4691 49.2132 67.3569 49.1571C67.2447 49.1011 67.1325 48.9889 67.0764 48.8206C67.0203 48.7084 66.9643 48.4841 66.9643 48.0914V41.3605H64.4401V41.9775C64.2718 41.8654 64.0475 41.8093 63.8792 41.7532C63.767 41.7532 63.7109 41.6971 63.5987 41.641C62.4769 41.3045 61.1869 41.3605 60.1771 41.8093C60.065 41.8654 60.0089 41.9215 59.8967 41.9215C59.3919 42.1458 58.9432 42.4824 58.5505 42.875C58.3262 43.0994 58.1579 43.3237 57.9896 43.5481C57.7653 43.8285 57.597 44.109 57.4848 44.4455C57.2043 45.0625 57.0922 45.6795 57.0922 46.3526C57.0922 47.0257 57.2043 47.6988 57.4848 48.2597C57.5409 48.3719 57.597 48.5402 57.7092 48.6523C57.9335 49.1011 58.214 49.4937 58.5505 49.8302C58.9992 50.279 59.5602 50.6155 60.1211 50.896C61.2429 51.4008 62.7012 51.4008 63.9352 51.0081C64.384 50.8399 64.7766 50.6155 65.1692 50.3911C65.3936 50.7277 65.674 51.0081 66.0667 51.2325C66.291 51.4008 66.5154 51.4569 66.7958 51.569C67.0763 51.6251 67.4128 51.6812 67.6933 51.6812C68.1981 51.6812 68.6468 51.569 69.0956 51.4008C69.4883 51.2325 69.8809 51.0081 70.2735 50.7277C70.6101 50.4472 70.9466 50.1107 71.171 49.7181C71.4514 49.3254 71.6197 48.9328 71.8441 48.4841C72.0123 48.0353 72.1806 47.5866 72.2367 47.1379C72.3489 46.6892 72.3489 46.1843 72.3489 45.7356C72.3489 44.8942 72.2367 43.9968 72.0123 43.2114C71.788 42.426 71.4514 41.6409 71.0027 40.9116C70.554 40.1824 70.0492 39.5654 69.4322 38.9485C68.8152 38.3316 68.1422 37.8267 67.3568 37.4341C66.6276 37.0415 65.7862 36.705 64.9449 36.4806C64.6084 36.3684 64.2718 36.3123 63.9353 36.2562C62.4769 36.0319 60.9624 36.088 59.5602 36.4806C58.7189 36.705 57.8775 37.0415 57.1484 37.4902C57.0362 37.5463 56.924 37.6585 56.8118 37.7146C56.1948 38.1072 55.6339 38.5559 55.1291 39.0608L54.9048 39.2851C54.3999 39.846 53.8951 40.463 53.5024 41.1362C53.0537 41.8654 52.7172 42.7067 52.4928 43.548C52.2684 44.3893 52.1562 45.2868 52.1562 46.2404C52.1562 47.0817 52.2684 47.9231 52.4367 48.7084C52.3806 48.7644 52.3806 48.8766 52.4367 48.9327V48.9328ZM64.4401 47.5305C64.384 47.6427 64.3279 47.6988 64.3279 47.7549C64.1036 48.0353 63.8792 48.2597 63.5987 48.428C63.2061 48.6523 62.7013 48.8206 62.1404 48.8206H62.0282C61.7478 48.8206 61.4673 48.7645 61.1868 48.6523C61.1308 48.6523 61.1308 48.6523 61.0747 48.5962C60.7381 48.4841 60.4577 48.2597 60.2333 48.0914C60.0089 47.8671 59.8407 47.5866 59.7285 47.3062C59.6163 47.0257 59.5602 46.6892 59.5602 46.3526C59.5602 46.1283 59.5602 45.9039 59.6724 45.6795C59.6724 45.5673 59.7285 45.4552 59.7846 45.3991C59.8968 45.0625 60.1211 44.8382 60.3455 44.6138C60.5699 44.3894 60.8503 44.2212 61.1868 44.0529C61.299 43.9968 61.4112 43.9968 61.4673 43.9407C61.6917 43.8846 61.9721 43.8285 62.1965 43.8285C62.4769 43.8285 62.7013 43.8285 62.9257 43.9407C63.15 43.9968 63.3744 44.109 63.5987 44.2212C63.7109 44.2773 63.8231 44.3894 63.9353 44.4455C63.9914 44.5016 64.1036 44.5577 64.1597 44.6699C64.2718 44.8382 64.4401 45.0064 64.4962 45.1747V47.5305H64.4401Z" fill="white"/>
                            <path d="M94.3922 52.6345C94.3922 49.83 93.4387 47.6424 91.4193 46.0158C90.578 45.3427 81.2669 37.2657 72.3485 29.5258H72.4607L69.0391 26.4969C67.076 24.8142 65.2811 23.1876 63.43 21.5609C63.0935 21.2805 62.7009 21.0561 62.3082 21H62.0839C61.6912 21.0561 61.2986 21.2805 60.962 21.5609C59.111 23.1876 52.0437 29.5258 52.0437 29.5258C43.1814 37.2663 33.8139 45.344 32.9729 46.0158C30.9536 47.6425 30 49.7738 30 52.6345C30.0561 60.2067 30 67.9476 30 75.4067V83.5399C30 85.7835 30.7292 87.6906 32.0193 88.9807C33.3654 90.3269 35.2725 91 37.4601 91H86.7635C89.0071 91 90.9142 90.2708 92.2044 88.9807C93.5505 87.6346 94.2236 85.7835 94.2236 83.5399V75.4067C94.3358 67.9465 94.3358 60.2064 94.3919 52.6345H94.3922ZM34.9361 49.2691C35.3848 48.8764 62.1955 25.4866 62.1955 25.4866C62.1955 25.4866 62.5882 25.8232 62.7564 25.9914C63.4295 26.5523 64.0465 27.0572 64.6635 27.6181C64.7757 27.7864 64.8879 27.9547 65.1122 28.1229C65.561 28.5156 71.2822 33.4515 77.284 38.7241C83.0613 43.7163 89.007 48.8766 89.4557 49.2692L89.5118 49.3253L73.3013 63.2358C72.4038 64.021 70.6651 65.4794 69.3189 66.6574C67.6362 65.199 65.8973 63.6845 64.2147 62.2263C64.0465 62.058 63.8782 61.9458 63.7099 61.7775C63.2612 61.441 62.8125 61.1044 62.2516 61.1605C61.6907 61.1044 61.2419 61.441 60.7932 61.7775C60.6249 61.9458 60.4567 62.058 60.2884 62.2263C58.6057 63.6846 56.8668 65.1991 55.1842 66.6574C53.7819 65.4795 52.0993 63.965 51.2018 63.2358L34.9349 49.2689L34.9361 49.2691ZM90.5781 75.0144V83.5963C90.5781 85.8961 89.288 87.2422 86.9882 87.2422H62.1955H37.4028C35.103 87.2422 33.813 85.8961 33.813 83.5963V75.1267V52.5776C36.9541 55.2699 42.3388 59.8694 43.4606 60.8228C44.4141 61.6642 45.3677 62.4495 46.3212 63.2908C47.7795 64.5248 49.9671 66.4319 51.8741 68.1146L52.6593 68.7877C49.5183 71.4801 46.4333 74.1724 43.2923 76.8648L42.507 77.5379C41.4413 78.4353 40.3756 79.3889 39.3098 80.2864C38.5245 80.9595 38.4123 81.9131 38.9732 82.6422C39.5902 83.3714 40.5438 83.4274 41.3851 82.7544C41.4412 82.6983 41.5533 82.6422 41.6094 82.5861L62.0264 64.9178L62.1947 65.03L62.3069 64.9178L82.7239 82.5861C82.78 82.6422 82.8922 82.6983 82.9482 82.7544C83.3409 83.0909 83.7896 83.2031 84.1822 83.2031C84.631 83.2031 85.0797 82.9787 85.3601 82.5861C85.9211 81.8569 85.8089 80.9594 85.0236 80.2303C83.9579 79.3328 82.8922 78.3792 81.8264 77.4818L81.0411 76.8087C77.9 74.1163 74.8151 71.424 71.674 68.7316L72.5715 67.9464C74.4786 66.3197 76.61 64.4687 78.0123 63.2347C78.9659 62.3934 79.9194 61.608 80.8729 60.7668C82.0508 59.7571 87.6599 54.9895 90.5205 52.5775C90.5766 60.0937 90.5766 67.6662 90.5766 75.0138L90.5781 75.0144Z" fill="white"/>
                        </svg>                        
                    </div>
                </div>
                <div class="sticky-banner--text--right" v-html="sticky.textRight"></div>
            </div>
        </div>
        <div class="sticky-banner--toggle" @click="closeBanner()">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" fill="#D9D9D9"/>
                <path d="M17.8846 15L21.9231 10.9615C22.6923 10.1923 22.6923 8.84615 21.9231 8.07692C21.1539 7.30769 19.8077 7.30769 19.0385 8.07692L15 12.1153L10.9615 8.07692C10.1923 7.30769 8.84615 7.30769 8.07692 8.07692C7.30769 8.84615 7.30769 10.1923 8.07692 10.9615L12.1154 15L8.07692 19.0385C7.30769 19.8077 7.30769 21.1539 8.07692 21.9231C8.46154 22.3077 8.94231 22.5 9.51923 22.5C10.0962 22.5 10.5769 22.3077 10.9615 21.9231L15 17.8846L19.0385 21.9231C19.4231 22.3077 19.9039 22.5 20.4808 22.5C20.9616 22.5 21.5385 22.3077 21.9231 21.9231C22.6923 21.1539 22.6923 19.8077 21.9231 19.0385L17.8846 15Z" fill="#333333"/>
            </svg>                    
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sticky-banner',
        props:
        {
          sticky: {
            type: Object,
            value: {},
          }
        },
        data(){
            return {
                //showBanner: this.$cookies.get('show-sticky-banner-promo-scalapay') !== 'false',
                showBanner: this.$cookies.get('show-sticky-banner-promo-newsletter') !== 'false',
                loading: true,
                delay: 1500,
            }
        },
        mounted()
        {
            let _this = this
            setTimeout(function(){
                _this.loading = false
            },this.delay)
        },
        methods:
        {
            closeBanner()
            {
                let _this = this
                //this.$cookies.set('show-sticky-banner-promo-scalapay', 'false', '3h')
                this.$cookies.set('show-sticky-banner-promo-newsletter', 'false', '3h')
                this.loading = true
                setTimeout(function(){
                    _this.showBanner = false
                },this.delay)
            },
            clickedBanner(){
                this.closeBanner()
                let elem = document.querySelector(".newsletter")
                if(elem) window.scrollTo(0, elem.offsetTop);
            },
        }
    }
</script>

<style lang="scss">

    .sticky-banner
    {
        transition:$transition-base;
        cursor:pointer;
        &.loading
        {
            transform: translateY(100%);
        }
        position:fixed;
        bottom:0;
        left:0;
        width: 100%;
        color:#000; 
        z-index: 999999;
        background: $white;
        &--wrap
        {
            display: flex;
            flex-wrap:wrap;
            position:relative;
            z-index: 1;
            @include media-breakpoint-up(lg)
            {
                //padding-right: 160px;
            }
        }
        &--text
        {
            flex:1;
            text-align: center;
            font-size: 13px;
            line-height: 120%;
            display:flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            &--left
            {
                @include customize-gradient();
                padding:12px;
                text-align: center;
                position:relative;
                min-height: 60px;
                flex:1;
                display:flex;
                align-items: center;
                justify-content: center;
                color:$white;
                font-weight: bold;
                flex:100%;
            }
            &--right
            {
                padding:12px;
                text-align: center;
                position:relative;
                min-height: 60px;
                flex:1;
                display:flex;
                align-items: center;
                justify-content: center;
                @include customize-color("tertiary");
                font-weight: bold;
                flex:100%;
            }
            @include media-breakpoint-up(md)
            {
                font-size: 14px;
                &--left,
                &--right
                {
                    padding:0 60px;
                }
            }
            @include media-breakpoint-up(xxl)
            {
                font-size: 20px;
                &--left,
                &--right
                {
                    padding:0;
                }
            }
            .sticky-banner--icon
            {
                width:50px;
                position:absolute;
                top:50%;
                right:0;
                transform:translateY(-50%) translateX(50%);
                svg
                {
                    width:100%;
                    height:auto;
                }
                @include media-breakpoint-up(lg)
                {

                }
            }
            @include media-breakpoint-down(sm)
            {
                font-size: 12px;
                &--left,
                &--right
                {
                    flex:100%;
                    text-align: left;
                    justify-content: flex-start;
                    padding:0 60px;
                }
                .sticky-banner--icon
                {
                    width:40px;
                    transform:translateY(50%) scaleX(-1);
                    top:auto;
                    bottom:0;
                    left:10px;
                }
            }
            @include media-breakpoint-up(md)
            {
                &--left
                {
                    flex:60%;
                }
                &--right
                {
                    flex:40%;
                }
            }
            /*
            .link
            {
                display:none;
            }
            @include media-breakpoint-up(md)
            {
                font-size: 18px;
                padding:14px;
                .link
                {
                    display: inline;
                    margin-left:30px;
                }
            }
            */
        }
        .link
        {
            font-size: 12px;
            color:$white;
            background: #000;
            padding:6px 15px;
            border-radius: 6px;
            transition:$transition-base;
            cursor:pointer;
            &:hover
            {
                background:$gray-800;
                color:$white;
            }
            @include media-breakpoint-up(md)
            {
                padding:9px 35px;
                font-size: 20px;
                border-radius: 10px;
            }
        }
        &--toggle
        {
            display:flex;
            align-items:center;
            justify-content: center;
            position: absolute;
            top:50%;
            transform:translateY(-50%);
            right:15px;
            z-index: 1;
            svg
            {
                cursor: pointer;
            }
            @include media-breakpoint-up(md)
            {

                right: 53px;

                svg
                {
                    margin-left:1rem;
                }
            }
        }
    }

</style>